"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerOrAuthorize = registerOrAuthorize;
var _events = require("../../types/events");
var _phoneAuth = require("../../types/phoneAuth");
var _action_types = require("../../constants/action_types");
var _jsonpRequest = require("../../../browser/utils/jsonpRequest");
var _registerOrAuthorizeUser = require("../../api/registerOrAuthorizeUser");
var _tracking = require("../../utils/tracking");
var _transformRegisterOrAutorizeResonse = require("../../api/registerOrAuthorizeUser/transformRegisterOrAutorizeResonse");
var _view = require("../view");
var _ = require("../../..");
var _rememberedAccounts = require("../../utils/rememberedAccounts");
var _rememberedAccounts2 = require("../../types/rememberedAccounts");
var _sendCode = require("../../api/sendCode");
var _formatString = require("../../utils/formatString");
function registerOrAuthorize(_ref) {
  let {
    code
  } = _ref;
  return async (dispatch, getState, context) => {
    dispatch({
      status: _phoneAuth.ERegisterOrAuthStatus.Loading,
      type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE
    });
    const {
      phoneAuth: {
        phone,
        sendValidationCode: {
          senderType
        }
      },
      agreement,
      isRememberAccountsFlow,
      source
    } = getState();
    try {
      const res = await (0, _registerOrAuthorizeUser.registerOrAuthorizeUser)(context.httpApi, {
        code,
        phone,
        isAcceptLicence: agreement.licenceAccepted,
        hasMarketingSubscriptions: agreement.marketingSubscriptionAccepted
      });
      switch (res.status) {
        case _transformRegisterOrAutorizeResonse.ERegisterOrAuthorizeEnhancedStatus.Success:
          {
            const {
              email,
              token,
              logOnUrl,
              isRegistered
            } = res;
            try {
              await (0, _jsonpRequest.jsonpRequest)(`${logOnUrl}?login=${encodeURIComponent(email)}&token=${token}&persistent=true`);
              dispatch({
                status: _phoneAuth.ERegisterOrAuthStatus.Succeed,
                type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE
              });
              if (isRegistered) {
                context.emitter.emit(_events.EEventType.RegisterSucceed, {
                  email,
                  phone,
                  senderType
                });
                (0, _tracking.trackRegistrationSuccess)({
                  senderType,
                  source
                });
              } else {
                context.emitter.emit(_events.EEventType.AuthenticateSucceed, {
                  email,
                  phone,
                  senderType
                });
                (0, _tracking.trackAuthenticateSuccess)({
                  senderType,
                  source
                });
              }
              if (isRememberAccountsFlow) {
                (0, _rememberedAccounts.saveAccount)({
                  type: _rememberedAccounts2.ERememberedAccountType.Phone,
                  value: (0, _formatString.formatPhoneWithSpecialChars)(phone)
                });
              }
            } catch (e) {
              context.logger.error(e, {
                domain: 'auth-widget.api.registerOrAuthorize#logon'
              });
              dispatch({
                status: _phoneAuth.ERegisterOrAuthStatus.Failed,
                type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
                error: 'Произошла непредвиденная ошибка'
              });
            }
            break;
          }
        case _transformRegisterOrAutorizeResonse.ERegisterOrAuthorizeEnhancedStatus.ManyAccounts:
          {
            const {
              accounts,
              phoneАccounts,
              temporaryToken
            } = res;
            dispatch({
              status: _phoneAuth.ERegisterOrAuthStatus.ManyAccounts,
              type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
              accounts,
              phoneАccounts,
              temporaryToken
            });
            dispatch((0, _view.changeView)(_.EActiveView.AccountSelect));
            break;
          }
        case _transformRegisterOrAutorizeResonse.ERegisterOrAuthorizeEnhancedStatus.CodeExpired:
          {
            const errorMessage = senderType === _sendCode.ESenderType.Call ? 'Истек срок действия кода' : 'Истек срок действия смс кода. Попробуйте ещё раз.';
            dispatch({
              status: _phoneAuth.ERegisterOrAuthStatus.Failed,
              type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
              error: errorMessage
            });
            break;
          }
        case _transformRegisterOrAutorizeResonse.ERegisterOrAuthorizeEnhancedStatus.Wrong:
          {
            let errorMessage;
            if (senderType === _sendCode.ESenderType.Call) {
              errorMessage = 'Введён неверный код';
              (0, _tracking.trackPhoneAuthCallValidationFail)(source);
            } else {
              errorMessage = 'Введён неверный код. Попробуйте ещё раз.';
              (0, _tracking.trackPhoneAuthSmsValidationFail)(source);
            }
            dispatch({
              status: _phoneAuth.ERegisterOrAuthStatus.Failed,
              type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
              error: errorMessage
            });
            break;
          }
        case _transformRegisterOrAutorizeResonse.ERegisterOrAuthorizeEnhancedStatus.CodeInputLimitReached:
          (0, _tracking.trackPhoneAuthExhausted)(source);
          dispatch({
            status: _phoneAuth.ERegisterOrAuthStatus.Failed,
            type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
            error: 'codeInputLimitReached'
          });
          dispatch((0, _view.changeView)(_.EActiveView.PhoneAuthValidateSms, {
            notice: {
              title: 'Попробуйте через час',
              text: 'Вы много раз ввели неверный код, и нам пришлось заблокировать аккаунт'
            }
          }));
          break;
        case _transformRegisterOrAutorizeResonse.ERegisterOrAuthorizeEnhancedStatus.Error:
          context.logger.error(`Ошибка авторизации ${res.status}`);
          dispatch({
            status: _phoneAuth.ERegisterOrAuthStatus.Failed,
            type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
            error: res.message || 'Произошла непредвиденная ошибка'
          });
          break;
        default:
          if (res.status === _transformRegisterOrAutorizeResonse.ERegisterOrAuthorizeEnhancedStatus.BrokenContract) {
            context.logger.error(`Нарушен контракт ${JSON.stringify(res.originalResponse)}`);
          } else {
            context.logger.error(`Ошибка авторизации ${res.status}`);
          }
          dispatch({
            status: _phoneAuth.ERegisterOrAuthStatus.Failed,
            type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
            error: 'Произошла непредвиденная ошибка'
          });
          break;
      }
    } catch (error) {
      context.logger.error(error, {
        domain: 'auth-widget.api.registerOrAuthorize'
      });
      dispatch({
        status: _phoneAuth.ERegisterOrAuthStatus.Failed,
        type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    }
  };
}